import { formatPrice } from "@/lib/utils";

/**
 * Ориентировочная сумма в USD: до ближайшего десятка ($10, $20, …).
 * Очень малые суммы — до ближайшего целого доллара.
 */
export function tjsToUsdApproxTens(amountTjs: number, tjsPerUsd: number): number {
  if (!Number.isFinite(amountTjs) || amountTjs <= 0) return 0;
  if (!Number.isFinite(tjsPerUsd) || tjsPerUsd <= 0) return 0;
  const usd = amountTjs / tjsPerUsd;
  let rounded = Math.round(usd / 10) * 10;
  if (rounded === 0 && usd > 0) {
    rounded = Math.round(usd);
    if (rounded === 0) rounded = 1;
  }
  return rounded;
}

/**
 * Для ru — только сомони. Для en — «TJS / ≈ $N» (N по курсу, ориентировочно).
 */
export function formatPriceTjsUsd(
  amountTjs: number,
  locale: string,
  tjsPerUsd: number
): string {
  const tjs = formatPrice(amountTjs);
  if (locale !== "en") return tjs;
  const usd = tjsToUsdApproxTens(amountTjs, tjsPerUsd);
  if (usd <= 0) return tjs;
  return `${tjs} / ≈ $${usd}`;
}
